module.exports = __webpack_public_path__ + "static/img/fot3_act.9cdb4f61.png";